// ============================================
// Auth Module - Events (ES6)
// 로그인/가입 이벤트 핸들러
// ============================================

import {
  handleGoogleLogin,
  handleAuth,
  showLoginMode,
  showSignupMode,
  showEmailLoginModal,
  closeEmailLoginModal,
  closeLoginModal,
  showLoginModal,
  showResetPasswordModal,
  closeResetPasswordModal,
  sendPasswordResetEmail,
  resendVerificationEmail,
  checkEmailVerification,
  closeEmailVerificationModal,
  handleLogout
} from './index.js';

// ============================================
// Auth Events Initialization
// ============================================

export function initAuthEvents() {
  // === Splash Auth Buttons ===
  const splashGoogleBtn = document.querySelector('.splash-auth-google');
  if (splashGoogleBtn) {
    splashGoogleBtn.addEventListener('click', handleGoogleLogin);
  }

  const splashEmailLink = document.querySelector('.splash-auth-email-link');
  if (splashEmailLink) {
    splashEmailLink.addEventListener('click', showEmailLoginModal);
  }

  // === Email Login Modal ===
  const emailLoginBackdrop = document.querySelector('#emailLoginModal .auth-modal-backdrop');
  if (emailLoginBackdrop) {
    emailLoginBackdrop.addEventListener('click', closeEmailLoginModal);
  }

  // 뒤로가기 버튼 (회원가입 모드면 로그인으로, 로그인 모드면 닫기)
  const emailLoginBackBtn = document.getElementById('emailLoginBackBtn');
  if (emailLoginBackBtn) {
    emailLoginBackBtn.addEventListener('click', () => {
      const isSignup = document.getElementById('emailNicknameGroup')?.style.display !== 'none';
      if (isSignup) {
        showLoginMode();
      } else {
        closeEmailLoginModal();
      }
    });
  }

  // 메인 제출 버튼
  const authSubmitBtn = document.getElementById('authSubmitBtn');
  if (authSubmitBtn) {
    authSubmitBtn.addEventListener('click', () => {
      const isSignup = document.getElementById('emailNicknameGroup')?.style.display !== 'none';
      handleAuth(isSignup ? 'signup' : 'login');
    });
  }

  // 모드 전환 버튼
  const authModeToggleBtn = document.getElementById('authModeToggleBtn');
  if (authModeToggleBtn) {
    authModeToggleBtn.addEventListener('click', () => {
      const isSignup = document.getElementById('emailNicknameGroup')?.style.display !== 'none';
      isSignup ? showLoginMode() : showSignupMode();
    });
  }

  // 비밀번호 찾기
  const forgotPasswordBtn = document.getElementById('forgotPasswordBtn');
  if (forgotPasswordBtn) {
    forgotPasswordBtn.addEventListener('click', showResetPasswordModal);
  }

  // 비밀번호 보기/숨기기 토글
  const passwordToggle = document.getElementById('passwordToggle');
  if (passwordToggle) {
    passwordToggle.addEventListener('click', () => {
      const input = document.getElementById('authPassword');
      if (input) {
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        // 아이콘 변경 (줄 그어진 눈 표시)
        passwordToggle.innerHTML = isPassword
          ? `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
              <line x1="1" y1="1" x2="23" y2="23"/>
            </svg>`
          : `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>`;
      }
    });
  }

  // 전체 동의 체크박스
  const agreeAll = document.getElementById('agreeAll');
  if (agreeAll) {
    agreeAll.addEventListener('change', (e) => {
      const agreeTerms = document.getElementById('agreeTerms');
      const agreePrivacy = document.getElementById('agreePrivacy');
      if (agreeTerms) agreeTerms.checked = e.target.checked;
      if (agreePrivacy) agreePrivacy.checked = e.target.checked;
    });
  }

  // 개별 약관 체크박스 변경 시 전체 동의 상태 업데이트
  const agreeTerms = document.getElementById('agreeTerms');
  const agreePrivacy = document.getElementById('agreePrivacy');
  const updateAgreeAll = () => {
    const agreeAll = document.getElementById('agreeAll');
    if (agreeAll && agreeTerms && agreePrivacy) {
      agreeAll.checked = agreeTerms.checked && agreePrivacy.checked;
    }
  };
  if (agreeTerms) agreeTerms.addEventListener('change', updateAgreeAll);
  if (agreePrivacy) agreePrivacy.addEventListener('change', updateAgreeAll);

  // === Password Reset Modal ===
  const resetBackdrop = document.querySelector('#resetPasswordModal .auth-modal-backdrop');
  if (resetBackdrop) {
    resetBackdrop.addEventListener('click', closeResetPasswordModal);
  }

  // 뒤로가기 버튼 (비밀번호 재설정 → 로그인)
  const resetPasswordBackBtn = document.getElementById('resetPasswordBackBtn');
  if (resetPasswordBackBtn) {
    resetPasswordBackBtn.addEventListener('click', () => {
      closeResetPasswordModal();
      showEmailLoginModal();
    });
  }

  const sendResetEmailBtn = document.getElementById('sendResetEmailBtn');
  if (sendResetEmailBtn) {
    sendResetEmailBtn.addEventListener('click', sendPasswordResetEmail);
  }

  // === Email Verification Modal ===
  // 이메일 인증 모달은 뒤로 버튼 없음 (인증 완료 전 빠져나갈 수 없음)

  const resendVerificationBtn = document.getElementById('resendVerificationBtn');
  if (resendVerificationBtn) {
    resendVerificationBtn.addEventListener('click', resendVerificationEmail);
  }

  const checkVerificationBtn = document.getElementById('checkVerificationBtn');
  if (checkVerificationBtn) {
    checkVerificationBtn.addEventListener('click', checkEmailVerification);
  }

  const verificationLogoutBtn = document.getElementById('verificationLogoutBtn');
  if (verificationLogoutBtn) {
    verificationLogoutBtn.addEventListener('click', handleLogout);
  }

  // === Legacy Login Modal ===
  const loginModalClose = document.querySelector('#loginModal .modal-close');
  if (loginModalClose) {
    loginModalClose.addEventListener('click', closeLoginModal);
  }

  const loginModalGoogle = document.querySelector('#loginModal .btn-google');
  if (loginModalGoogle) {
    loginModalGoogle.addEventListener('click', handleGoogleLogin);
  }

  const loginModalEmail = document.querySelector('#loginModal .auth-form .btn-secondary');
  if (loginModalEmail) {
    loginModalEmail.addEventListener('click', () => {
      closeLoginModal();
      showEmailLoginModal();
    });
  }

  // === Feed Login Button ===
  const feedLoginBtn = document.querySelector('.feed-login-btn');
  if (feedLoginBtn) {
    feedLoginBtn.addEventListener('click', () => {
      showLoginModal();
    });
  }

  console.log('[Auth Events] 이벤트 리스너 초기화 완료');
}
